
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M3.09011 4.44C2.70011 4.83 2.70011 5.46 3.09011 5.85L5.12011 7.88L5.00011 8.01V19C5.00011 20.1 5.90011 21 7.00011 21H17.0001C17.3501 21 17.6801 20.9 17.9701 20.74L19.1401 21.91C19.5301 22.3 20.1601 22.3 20.5501 21.91C20.9401 21.52 20.9401 20.89 20.5501 20.5L4.50011 4.44C4.11011 4.05 3.48011 4.05 3.09011 4.44ZM19.0001 16.11V5C19.0001 3.9 18.1001 3 17.0001 3H10.0101L7.95011 5.06L19.0001 16.11Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-sim`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoSim

    ```js
    <b-new-b-icon-no-sim />
    ```
</docs>


